import Flex from '../Common/Flex';
import DesktopView from './DesktopView';
import MobileView from './MobileView';
import { FC } from 'react';
import { ContainerProps } from './types';
import { useIsLargerScreen } from '../../hooks/useIsMobileView';
import MarketingBanner from '../Common/MarketingBanner';

const Container: FC<ContainerProps> = ({ children, backgroundColor }) => {
  if (useIsLargerScreen()) {
    return (
      <Flex width="100%" height="100vh" flexDirection={'column'}>
        <MarketingBanner />
        <DesktopView backgroundColor={backgroundColor}>{children}</DesktopView>
      </Flex>
    );
  }
  return (
    <MobileView backgroundColor={backgroundColor}>
      <MarketingBanner />
      {children}
    </MobileView>
  );
};

export default Container;
